import { isMail } from 'components/mail/scheduleSlots';
import { formatPhone, phoneErrorCode } from 'helper/prospectPhone';

// One list for the add panel and the coming prospect sheet; `field` stays
// readable on existing data but is no longer offered.
export const PROSPECT_SOURCES = [
  'phone',
  'field_visit',
  'referral',
  'search',
  'social',
  'inbound',
];

export const DEFAULT_PROSPECT_SOURCE = 'phone';

// Contract 6 of the api (/prospect/create): a « social » prospect names its
// network, a « referral » one the person who recommended it; neither is sent
// for any other source, the api would ignore them.
export const SOCIAL_NETWORKS = [
  'linkedin',
  'facebook',
  'instagram',
  'tiktok',
  'other',
];

export const emptyReferrer = () => ({
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
});

const trimmed = (value) => String(value ?? '').trim();

// Per field, the error code of the referrer, or null: names required, the
// e-mail and the number checked when filled, one of the two at least.
export const referrerErrors = (referrer) => {
  const email = trimmed(referrer?.email);
  const phone = trimmed(referrer?.phone);
  return {
    firstname: trimmed(referrer?.firstname) ? null : 'required',
    lastname: trimmed(referrer?.lastname) ? null : 'required',
    email: email && !isMail(email) ? 'invalid' : null,
    phone: phone ? phoneErrorCode(phone) : null,
    reach: email || phone ? null : 'required',
  };
};

export const isSourceDetailValid = ({ source, sourceNetwork, referrer }) => {
  if (source === 'social') return SOCIAL_NETWORKS.includes(sourceNetwork);
  if (source === 'referral') {
    return Object.values(referrerErrors(referrer)).every((code) => !code);
  }
  return true;
};

// The fields to add to the prospect's: nothing for the other sources.
export const sourceDetailFields = ({ source, sourceNetwork, referrer }) => {
  if (source === 'social') return { sourceNetwork };
  if (source !== 'referral') return {};
  const email = trimmed(referrer.email).toLowerCase();
  const phone = trimmed(referrer.phone);
  return {
    referrer: {
      firstname: trimmed(referrer.firstname),
      lastname: trimmed(referrer.lastname),
      ...(email ? { email } : {}),
      ...(phone ? { phone: formatPhone(phone) } : {}),
    },
  };
};
